import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import filters from "@/filters";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
import "@/styles/index.css";
import qs from "qs";
import { commonAPI } from "@/api";
import mixinCommon from "@/mixins/Common";
import "./utils/dirlogs"; //弹窗拖拽
import moment from "moment";
import Components from "@/components"; //公共组件
import i18n from "@/lang";
import lodash from "lodash";
Vue.prototype.lodash = lodash;
Vue.use(Components);
Vue.prototype.$API = commonAPI;
Vue.prototype.$qs = qs;
Vue.prototype.$moment = moment;
Vue.use(ElementUI, {
    size: 'mini', // 
})
Vue.config.productionTip = false;
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
Vue.mixin(mixinCommon);
const jsBase64 = require('js-base64').Base64 //重要
Vue.prototype.$Base64 = jsBase64;
new Vue({
    router,
    store,
    i18n, 
    render: h => h(App)
  }).$mount('#app')
